import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import SiteNotification from './SiteNotification';

import './site-notification.scss';


/**
 * @description: Site notification container. Listens for new notifications pushed.
 * @param {*}
 * @return {*}
 */
const SiteNotificationContainer = () => {
  const notifications = useSelector((state) => state.global.siteNotifications);

  // Keep state of heights for transforms.
  const spacing = 10;
  const [heights, setHeights] = useState([]);
  const [translations, setTranslations] = useState([]);

  const updateHeights = (uuid, height, type = 'add') => {
    switch(type) {
      case 'add':
        setHeights([...heights, { uuid, height }]);
        break;
      case 'remove':
        setHeights(heights.filter(h => h.uuid !== uuid));
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    let height = 0;
    setTranslations(heights.map(h => {
      const oldHeight = height;
      height += h.height + spacing;
      return oldHeight;
    }));
  }, [heights]);

  return (
    <div className="site-notifications-container">
      {notifications.map((notification, i) => {
        const translate = translations[i] ?? 0;
        return (
          <SiteNotification
            key={notification.uuid}
            updateHeights={updateHeights}
            translate={translate}
            {...notification}
          />
        );
      })}
    </div>
  );
};

export default SiteNotificationContainer;
